import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import enums from './modules/enums'

Vue.use(Vuex)

const plugin = store => {
  let storage = window.sessionStorage
  for (let i = 0, length = storage.length; i < length; i++) {
    if (storage.key(i).indexOf('staff') === 0) {
      let _keys = storage
        .key(i)
        .split('_')
      _keys.shift()
      store.state[_keys.shift()][_keys.join('_')] = storage.getItem(storage.key(i)) && storage.getItem(storage.key(i)) !== 'undefined' ? JSON.parse(storage.getItem(storage.key(i))) : ''
    }
  }
  store.subscribe(mutation => {
    mutation
      .type
      .indexOf('RECORD') === 0 && storage.setItem(mutation.type.replace('RECORD', 'staff').toLowerCase(), JSON.stringify(mutation.payload))
  })
}

export default new Vuex.Store({
  state: {
    collapse: false
  },
  modules: {
    global,
    enums
  },
  actions: {
    toggle ({ state }) {
      state.collapse = !state.collapse
    }
  },
  plugins: [plugin]
})
